import React, { PropTypes, Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './MobileMenu.css';

// Components
import Item from '../item/Item';
import LocaleContainer from '../../../../containers/LocaleContainer';

const propTypes = {
  locale: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  extra: PropTypes.array.isRequired,
  menuState: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
};

class MobileMenu extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.toggleMenu(false);
  }

  render() {
    const items = this.props.items.map((item) => {
      const to = item[this.props.locale];
      const name = (
        <FormattedMessage
          id={item.name}
          description="MobileMenu item"
        />
      );

      return <Item key={item.name} to={to}>{name}</Item>;
    });

    const extra = (
      this.props.extra.map((item) => {
        const to = item[this.props.locale];
        const name = (
          <FormattedMessage
            id={item.name}
            description="MobileMenu item"
          />
        );
        return <Item key={item.name} to={to}>{name}</Item>;
      })
    );

    const menu = this.props.menuState &&
    (
      <div key="menu" onClick={this.handleClick} className="mobile menu container">
        <nav className="ui big vertical secondary mobile inverted blue menu">
          <a className="close item">
            <i className="close big icon" />
          </a>
          <div className="brand item">
            <FormattedMessage
              id="shortTitle"
              description="App short title"
            />
          </div>
          <div className="ui hidden divider" />
          {items}
          {extra}
          <div className="ui divider" />
          <div className="language item">
            <LocaleContainer />
          </div>
          <div className="ui hidden divider" />
        </nav>
      </div>
    );

    return (
      <ReactCSSTransitionGroup
        transitionName="menu"
        transitionEnterTimeout={300}
        transitionLeaveTimeout={300}
      >
        {menu}
      </ReactCSSTransitionGroup>
    );
  }
}

MobileMenu.propTypes = propTypes;

export default MobileMenu;



/** WEBPACK FOOTER **
 ** ./src/components/layout/nav/mobileMenu/MobileMenu.js
 **/